import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Protected } from "@/components/Protected";

import Landing from "@/pages/Landing";
import { Login, Register } from "@/pages/Auth";
import { SetupCoach, AcceptInvite, ChangePassword } from "@/pages/SetupInvite";
import { Pricing, Apply, Program, Privacy } from "@/pages/Marketing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Nutrition from "@/pages/Nutrition";
import Workouts from "@/pages/Workouts";
import ProgressPage from "@/pages/Progress";
import CheckIn from "@/pages/CheckIn";
import { ClientMessages, CoachMessages } from "@/pages/Messages";
import { CoachDashboard, CoachClientDetail, CoachApplications } from "@/pages/Coach";

function RoleRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-neutral-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return <Navigate to={user.role === "coach" ? "/coach" : "/app/dashboard"} replace/>;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing/>} />
            <Route path="/program" element={<Program/>} />
            <Route path="/pricing" element={<Pricing/>} />
            <Route path="/apply" element={<Apply/>} />
            <Route path="/privacy" element={<Privacy/>} />
            <Route path="/login" element={<Login/>} />
            <Route path="/register" element={<Navigate to="/apply" replace/>} />
            <Route path="/setup-coach" element={<SetupCoach/>} />
            <Route path="/invite/:token" element={<AcceptInvite/>} />
            <Route path="/change-password" element={<Protected><ChangePassword/></Protected>} />

            <Route path="/onboarding" element={<Protected role="client"><Onboarding/></Protected>} />
            <Route path="/go" element={<RoleRedirect/>} />

            <Route path="/app/dashboard" element={<Protected role="client"><Dashboard/></Protected>} />
            <Route path="/app/nutrition" element={<Protected role="client"><Nutrition/></Protected>} />
            <Route path="/app/workouts" element={<Protected role="client"><Workouts/></Protected>} />
            <Route path="/app/progress" element={<Protected role="client"><ProgressPage/></Protected>} />
            <Route path="/app/checkin" element={<Protected role="client"><CheckIn/></Protected>} />
            <Route path="/app/messages" element={<Protected role="client"><ClientMessages/></Protected>} />

            <Route path="/coach" element={<Protected role="coach"><CoachDashboard/></Protected>} />
            <Route path="/coach/clients/:id" element={<Protected role="coach"><CoachClientDetail/></Protected>} />
            <Route path="/coach/applications" element={<Protected role="coach"><CoachApplications/></Protected>} />
            <Route path="/coach/messages" element={<Protected role="coach"><CoachMessages/></Protected>} />

            <Route path="*" element={<Navigate to="/" replace/>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
